import { render } from "./CarrerWithUs.vue?vue&type=template&id=f2656bc4&scoped=true"
import script from "./CarrerWithUs.vue?vue&type=script&lang=js"
export * from "./CarrerWithUs.vue?vue&type=script&lang=js"

import "./CarrerWithUs.vue?vue&type=style&index=0&id=f2656bc4&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/theearcasino/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2656bc4"]])

export default __exports__